import { Component, input } from '@angular/core';
import { SafeHtmlPipe } from '@boels/helpers';

import { BOProduct, ProductType } from '@boels/models';
import { CmsRouterLinkDirective } from '@boels/shared-state';

@Component({
  selector: 'boels-product-title',
  imports: [CmsRouterLinkDirective, SafeHtmlPipe],
  templateUrl: './product-title.component.html',
  styleUrl: './product-title.component.scss',
})
export class ProductTitleComponent {
  product = input.required<BOProduct>();
  variant = input.required<ProductType>();
}
